/* eslint-disable prefer-arrow/prefer-arrow-functions */
/**
 * A helper function to improve typings of object keys
 *
 * @param obj Object
 */
export function keys(obj) {
    return Object.keys(obj);
}
//# sourceMappingURL=utils.js.map